import { z } from 'zod/v4';
import { FilterSchema } from '../query/schema.js';
import { ViewVisibilityType } from './visibility.js';
export const AugmentedFilterSchema = FilterSchema.and(z.object({
    id: z.uuid(),
    filterKey: z.string(),
}));
// `base` cannot be a z.enum over db.schema.entities: db.ts imports this module for
// the views.options column schema, so importing it back would be a cycle.
const EntityNameSchema = z.custom((value) => typeof value === 'string');
// The annotation is load-bearing: views.options is typed by what this schema infers,
// so without it the schema silently widens (base: string, filters: FilterX<any>) and
// every consumer needs a cast back to ViewDescription.
export const ViewDescriptionSchema = z.object({
    base: EntityNameSchema,
    displayOptions: z.array(z.string()),
    filters: z.array(AugmentedFilterSchema),
    orderBy: z.string(),
    orderByDirection: z.enum(['ASC', 'DESC']).optional(),
    preview: z
        .object({
        header: z.string().optional(),
        content: z.string().optional(),
    })
        .optional(),
});
export const CreateViewSchema = z.object({
    id: z.uuid().optional(),
    name: z.string(),
    options: ViewDescriptionSchema,
    visibility: z.enum(ViewVisibilityType),
});
export const UpdateViewSchema = z.object({
    name: z.string().optional(),
    options: ViewDescriptionSchema.optional(),
    visibility: z.enum(ViewVisibilityType).optional(),
});
//# sourceMappingURL=index.js.map